import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { CreatePackageRequest, PackageResponse } from "./packagesApi";
import { createPackage } from "./packagesApi";

export const useCreatePackage = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const createPackageMutation = useMutation<PackageResponse, unknown, CreatePackageRequest>({
    mutationFn: (v) => createPackage(v),
    onSuccess: (data) => {
      enqueueSnackbar(`Pakiet ${data.name.value} został utworzony`, { variant: "success" });
      queryClient.invalidateQueries({ queryKey: ["packages"] });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się stworzyć pakietu. Powód: ${(error as Error).message}`, { variant: "error" });
    },
  });

  return { createPackage: (request: CreatePackageRequest) => createPackageMutation.mutateAsync(request) };
};
